import { render, staticRenderFns } from "./dcsUpload.vue?vue&type=template&id=fa230d7a&"
import script from "./dcsUpload.vue?vue&type=script&lang=js&"
export * from "./dcsUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports